/**
 * The Terms of Service "Last updated" date. The page shows it and the
 * concierge knowledge base quotes it (server/tommy-concierge.js), so both
 * read it here. Section 2.17 (Travel Insurance by Faye) and its carve-outs
 * render with the Faye launch flag, and that version carried the later date
 * until both took 2.5.1 (Flight Alert Texts) on October 24, 2026.
 */
export const TERMS_LAST_UPDATED = 'October 24, 2026';
export const TERMS_LAST_UPDATED_WITH_FAYE = 'October 24, 2026';

/** The date for the version on show: with or without the Faye section. */
export function termsLastUpdated(fayeInsurance) {
  return fayeInsurance ? TERMS_LAST_UPDATED_WITH_FAYE : TERMS_LAST_UPDATED;
}
